import { render, staticRenderFns } from "./AppointExpertAdd.vue?vue&type=template&id=0a52bdea&scoped=true"
import script from "./AppointExpertAdd.vue?vue&type=script&lang=js"
export * from "./AppointExpertAdd.vue?vue&type=script&lang=js"
import style0 from "./AppointExpertAdd.vue?vue&type=style&index=0&id=0a52bdea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a52bdea",
  null
  
)

export default component.exports